import { render, staticRenderFns } from "./shortageRegistration.vue?vue&type=template&id=d1de8b68&scoped=true"
import script from "./shortageRegistration.vue?vue&type=script&lang=js"
export * from "./shortageRegistration.vue?vue&type=script&lang=js"
import style0 from "./shortageRegistration.vue?vue&type=style&index=0&id=d1de8b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1de8b68",
  null
  
)

export default component.exports